export const READ_ONLY_MODE = true;